import { render, staticRenderFns } from "./construct.vue?vue&type=template&id=99f308bc&scoped=true&"
import script from "./construct.vue?vue&type=script&lang=js&"
export * from "./construct.vue?vue&type=script&lang=js&"
import style0 from "./construct.vue?vue&type=style&index=0&id=99f308bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f308bc",
  null
  
)

export default component.exports